import React, { useContext } from "react";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { AppContext } from "../App";
import { elementsOverlap } from "../data/sport-utils";
import { getConfiguration } from '../data/utils/configuration';
import './arrowAdviseToReachBonusContainer.css';
function AdviceToReachBonusContainer(props) {
    const conf = getConfiguration();
    const ctxt = useRef({}).current;
    ctxt.appContext = useContext(AppContext);
    const isCollapsable = conf?.cba;
    const containerRef = useRef();
    const arrowContainerRef = useRef();
    const [initialTopButtonMarginBottom,setInitialTopButtonMarginBottom] = useState(null);
    const topButton = document.getElementById("top-button");

    function handleCollapse(e){
        e.stopPropagation();
        e.preventDefault();
        ctxt.appContext.toggleAdviceBonus();
    }
    
    function handleClick(e){
        if(props.onClick){
            props.onClick(e);
        }
    }

    function onVisibilityChange(element, callbackOnVisible, callbackOnNotVisible) {
        const observer = 
        new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if(entry.intersectionRatio > 0) {
                callbackOnVisible();
              //observer.disconnect();
            }else{
                //console.log("it's not visible")
                callbackOnNotVisible();
            }
          });
        });
        observer.observe(element);
        return observer;
    }


    

    function handleOverlapsWithTopButton(element){
        if(isCollapsable){
            if(topButton && element) {
                var style = window.getComputedStyle(topButton);
                if(style.display === 'none'){
                    topButton.style.marginBottom = initialTopButtonMarginBottom;
                }else{
                    const overlaps = elementsOverlap(element,topButton);
                    const  marginBottom = parseInt(window.getComputedStyle(topButton).marginBottom,10);

                    if(overlaps){
                        if(!ctxt.appContext.adviceBonusCollapsed){
                            topButton.style.marginBottom = (marginBottom+(element?.getBoundingClientRect()?.height)) + 'px';
                        }
                    }else{
                        if(ctxt.appContext.adviceBonusCollapsed){
                            topButton.style.marginBottom = initialTopButtonMarginBottom;
                        }else{

                        }
                    }
                }
               
            }
        }
    }

    useEffect(()=>{
        if(isCollapsable){
            handleOverlapsWithTopButton(containerRef.current);
        }
    },[ctxt.appContext.adviceBonusCollapsed]);

    useEffect(()=>{
        let observer;
        if(isCollapsable){
            var style = window.getComputedStyle(topButton);
            if(style.display === 'none'){
                setInitialTopButtonMarginBottom((parseInt(window.getComputedStyle(topButton).marginBottom,10))+'px');
            }else{
                setInitialTopButtonMarginBottom('0px');
            }
            observer = onVisibilityChange(topButton,() =>{handleOverlapsWithTopButton(containerRef.current)}, () => {topButton.style.marginBottom = initialTopButtonMarginBottom});
            
        }
        
        
        return () => {
            if(isCollapsable){
                topButton.style.marginBottom = initialTopButtonMarginBottom;
                observer?.disconnect();
            }
        }
    
    },[]);



    return (
        <div ref={containerRef} className={`adviseToReachBonusContainer ${props.isBetslip?'betslipAdvise':'sportbook-footer'} ${ctxt.appContext.adviceBonusCollapsed?'adviseToReachBonusContainer--collapsed':''} `} onClick={handleClick}>
            {isCollapsable && 
            <div ref={arrowContainerRef} className="adviseToReachBonusContainer__arrowContainer" onClick={handleCollapse} ></div>
            }
			<span className={"iconContainer"}> <i className={"fas fa-gift"} /> </span>
			<span className={"textContainer"}>  {props.bonusAdvice} </span> 
		</div>
    )

}

export default AdviceToReachBonusContainer;